import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {mobileOnlyLinaria} from '../../../constants/customMedia';
import {Text} from '../Text';

export const TermsAndConditionsHeader: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const {t} = useTranslation();

  return (
    <HeaderText>{children || t('Promotion Terms & Conditions')}</HeaderText>
  );
};

export const TermsAndConditionsBody: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <BodyText data-testid="termsAndConditions">{children}</BodyText>;
};

const HeaderText = styled(Text)`
  flex: 1;
  text-align: center;
`;

const BodyText = styled(Text)`
  ${mobileOnlyLinaria(`
    display: flex;
    flex: 1;
    line-height: 1.4;
  `)}
`;
